export class PanelStyles {
  static getCSS(): string {
    return `
      :root { --ce-z: 2147483647; }
      .ce-panel {
        position: fixed; top: 12px; right: 12px; width: 360px;
        background: linear-gradient(135deg, #1a1a1a 0%, #0f0f0f 100%);
        color: #fff; font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
        border: 1px solid rgba(255,255,255,.12); border-radius: 12px; z-index: 9999999999;
        box-shadow: 0 16px 48px rgba(0,0,0,.4), 0 0 0 1px rgba(255,255,255,.05);
        overflow: hidden;
        pointer-events: auto !important;
      }
      /* Ensure panel content is always on top */
      .ce-panel * {
        z-index: inherit !important;
      }
      /* Create a safe zone around the panel */
      .ce-panel::before {
        content: '';
        position: absolute;
        top: -10px; left: -10px; right: -10px; bottom: -10px;
        z-index: -1;
        pointer-events: none;
      }
      .ce-panel header {
        display:flex; align-items:center; justify-content:space-between;
        padding: 12px 16px; background: rgba(255,255,255,.08);
        border-bottom: 1px solid rgba(255,255,255,.12);
        font-weight: 700; font-size: 14px;
      }
      .ce-panel header > div:first-child {
        display: flex; align-items: center; gap: 8px;
      }
      .ce-logo {
        color: #00e5ff;
      }
      .ce-panel header .ce-badge {
        font-weight: 600; font-size: 9px; padding: 3px 6px; border-radius: 10px;
        background: linear-gradient(135deg, #00e5ff, #0099cc); border: none; color: #fff;
        margin-left: 6px; text-transform: uppercase; letter-spacing: 0.5px;
      }
      .ce-panel .ce-body { padding: 16px; display:flex; flex-direction:column; gap: 12px; }
      .ce-row { display:flex; gap: 8px; }
      .ce-col { display:flex; flex-direction:column; gap: 6px; }
      .ce-section { display: flex; flex-direction: column; gap: 8px; }
      .ce-section-header {
        display: flex; align-items: center; gap: 6px;
        font-weight: 600; font-size: 11px; color: #00e5ff;
        text-transform: uppercase; letter-spacing: 0.5px;
      }
      .ce-icon { opacity: 0.8; }
      .ce-status-bar {
        display: flex; align-items: center; gap: 6px;
        padding: 8px 12px; background: rgba(0,229,255,.1);
        border: 1px solid rgba(0,229,255,.2); border-radius: 6px;
        font-size: 12px; font-weight: 500;
      }
      .ce-status-indicator {
        width: 6px; height: 6px; border-radius: 50%;
        background: #00e5ff; animation: pulse 2s infinite;
      }
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
      .ce-page-path {
        padding: 6px 10px; background: rgba(255,255,255,.05);
        border: 1px solid rgba(255,255,255,.1); border-radius: 4px;
        font-size: 11px; word-break: break-all;
      }
      .ce-label { font-size: 11px; opacity: .9; font-weight: 500; }
      .ce-action-help, .ce-value-help, .ce-selector-help {
        font-size: 10px; color: rgba(255,255,255,.5);
        margin-top: 4px;
        line-height: 1.3;
      }
      .ce-element-preview {
        background: rgba(255,255,255,.05);
        border: 1px solid rgba(255,255,255,.1);
        border-radius: 6px;
        padding: 8px;
        margin-bottom: 8px;
      }
      .ce-element-info {
        display: flex;
        flex-direction: column;
        gap: 2px;
      }
      .ce-element-type {
        font-size: 11px;
        color: #00e5ff;
        font-weight: 500;
      }
      .ce-element-name {
        font-size: 10px;
        color: rgba(255,255,255,.7);
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New";
      }
      .ce-input, .ce-select, .ce-textarea {
        width:100%; box-sizing:border-box;
        background: rgba(255,255,255,.08); border: 1px solid rgba(255,255,255,.15);
        color:#fff; border-radius: 6px; padding: 8px; outline:none;
        font-size: 13px; transition: all 0.2s ease;
      }
      .ce-input:focus, .ce-select:focus, .ce-textarea:focus {
        border-color: #00e5ff; background: rgba(255,255,255,.12);
        box-shadow: 0 0 0 2px rgba(0,229,255,.1);
      }
      .ce-textarea { min-height: 60px; resize: vertical; }
      .ce-btn {
        cursor:pointer; border-radius: 6px; padding: 8px 12px; border: 1px solid rgba(255,255,255,.15);
        background: rgba(255,255,255,.08); color:#fff; font-weight: 600;
        font-size: 13px; display: flex; align-items: center; gap: 6px;
        transition: all 0.2s ease;
      }
      .ce-btn:hover {
        background: rgba(255,255,255,.12);
        border-color: rgba(255,255,255,.25);
        transform: translateY(-1px);
      }
      .ce-btn:active { transform: translateY(0); }
      .ce-btn svg { flex-shrink: 0; }
      .ce-btn-primary {
        background: linear-gradient(135deg, #00e5ff, #0099cc);
        border-color: #00e5ff; color: #000;
      }
      .ce-btn-primary:hover {
        background: linear-gradient(135deg, #00ffff, #00e5ff);
        box-shadow: 0 2px 8px rgba(0,229,255,.3);
      }
      .ce-btn-danger {
        background: linear-gradient(135deg, #ff4757, #c0392b);
        border-color: #ff4757; color: #fff;
      }
      .ce-btn-danger:hover {
        background: linear-gradient(135deg, #ff6b7a, #ff4757);
        box-shadow: 0 2px 8px rgba(255,71,87,.3);
      }
      .ce-help { font-size: 10px; opacity: .7; line-height: 1.4; }
      .ce-divider { height: 1px; background: linear-gradient(90deg, transparent, rgba(255,255,255,.1), transparent); margin: 6px 0; }
      .ce-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New"; font-size: 11px; }
      .ce-list {
        max-height: 200px; overflow:auto; border: 1px solid rgba(255,255,255,.1);
        border-radius: 6px; padding: 6px; background: rgba(255,255,255,.03);
      }
      .ce-list::-webkit-scrollbar { width: 4px; }
      .ce-list::-webkit-scrollbar-track { background: rgba(255,255,255,.05); border-radius: 2px; }
      .ce-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,.2); border-radius: 2px; }
      .ce-item {
        padding: 8px; border-radius: 6px; border: 1px solid rgba(255,255,255,.08);
        margin-bottom: 6px; background: rgba(255,255,255,.02);
        transition: all 0.2s ease;
      }
      .ce-item:hover {
        background: rgba(255,255,255,.05);
        border-color: rgba(0,229,255,.3);
        transform: translateX(-1px);
      }
      .ce-item:last-child { margin-bottom: 0; }
      .ce-item-header {
        display: flex; justify-content: space-between; align-items: flex-start;
        margin-bottom: 6px;
      }
      .ce-item-info { flex: 1; }
      .ce-item-actions {
        display: flex; gap: 3px;
      }
      .ce-item-actions {
        display:flex; gap:6px; margin-top:8px;
        flex-wrap: wrap;
      }
      .ce-mini { font-size: 11px; opacity: .9; }
      .ce-mini-btn {
        cursor:pointer; font-weight:600; font-size:10px; padding: 3px 6px;
        border-radius: 3px; border: 1px solid rgba(255,255,255,.2);
        background: rgba(255,255,255,.1); color: #fff;
        transition: all 0.2s ease;
      }
      .ce-mini-btn:hover {
        background: rgba(255,255,255,.2);
        border-color: rgba(255,255,255,.4);
      }
      .ce-mini-btn.danger {
        background: rgba(255,71,87,.2);
        border-color: rgba(255,71,87,.4);
      }
      .ce-mini-btn.danger:hover {
        background: rgba(255,71,87,.3);
        border-color: rgba(255,71,87,.6);
      }
      .ce-footer {
        display: flex; justify-content: space-between; align-items: center;
        background: rgba(0,0,0,.2);
        font-size: 9px; opacity: .6;
      }
      .ce-footer .ce-btn {
        font-size: 12px; padding: 6px 12px;
        opacity: 1;
        transition: all 0.2s ease;
        background: rgba(255,255,255,.1);
        border-color: rgba(255,255,255,.2);
      }
      .ce-footer .ce-btn:hover {
        background: rgba(255,255,255,.15);
        border-color: rgba(255,255,255,.3);
        transform: translateY(-1px);
      }
      .ce-footer .ce-btn.ce-btn-primary {
        background: linear-gradient(135deg, #00e5ff, #0099cc);
        border-color: #00e5ff;
        color: #000;
      }
      .ce-footer .ce-btn.ce-btn-primary:hover {
        background: linear-gradient(135deg, #00ffff, #00e5ff);
        box-shadow: 0 2px 8px rgba(0,229,255,.3);
      }
      
      /* Image Upload Styles */
      .ce-image-upload {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      
      .ce-upload-area {
        border: 2px dashed rgba(255,255,255,.3);
        border-radius: 8px;
        padding: 16px;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease;
        background: rgba(255,255,255,.02);
        position: relative;
        z-index: 1;
      }
      
      .ce-upload-area:hover {
        border-color: #00e5ff;
        background: rgba(0,229,255,.05);
      }
      
      .ce-upload-area.dragover {
        border-color: #00e5ff;
        background: rgba(0,229,255,.1);
        transform: scale(1.02);
      }
      
      .ce-upload-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }
      
      .ce-upload-icon {
        color: rgba(255,255,255,.6);
        transition: color 0.2s ease;
        width: 36px;
        height: 36px;
      }
      
      .ce-upload-area:hover .ce-upload-icon {
        color: #00e5ff;
      }
      
      .ce-upload-text {
        display: flex;
        flex-direction: column;
        gap: 2px;
      }
      
      .ce-upload-title {
        font-weight: 600;
        font-size: 14px;
        color: #fff;
      }
      
      .ce-upload-subtitle {
        font-size: 12px;
        color: rgba(255,255,255,.6);
      }
      
      .ce-image-preview {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px;
        background: rgba(255,255,255,.05);
        border-radius: 8px;
        border: 1px solid rgba(255,255,255,.1);
      }
      
      .ce-image-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      
      .ce-image-name {
        font-size: 12px;
        color: rgba(255,255,255,.8);
        font-family: ui-monospace, SFMono-Regular, SF Mono, Consolas, Liberation Mono, Menlo, monospace;
      }
      
      .ce-upload-status {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px;
        background: rgba(255,255,255,.05);
        border-radius: 8px;
      }
      
      .ce-upload-progress {
        width: 100%;
        height: 4px;
        background: rgba(255,255,255,.1);
        border-radius: 2px;
        overflow: hidden;
      }
      
      .ce-progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #00e5ff, #0099cc);
        border-radius: 2px;
        width: 0%;
        transition: width 0.3s ease;
        animation: ce-progress-pulse 1.5s ease-in-out infinite;
      }
      
      @keyframes ce-progress-pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
      }
      
      .ce-upload-message {
        font-size: 12px;
        color: #00e5ff;
        text-align: center;
      }
      
      .ce-btn-small {
        padding: 4px 8px;
        font-size: 11px;
      }

      /* Element Selection Guidance */
      .ce-element-guidance {
        padding: 20px;
        background: rgba(0,229,255,.05);
        border: 1px solid rgba(0,229,255,.2);
        border-radius: 8px;
        text-align: center;
        margin: 12px 0;
      }

      .ce-guidance-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }

      .ce-guidance-icon {
        font-size: 24px;
        opacity: 0.8;
      }

      .ce-guidance-text {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .ce-guidance-title {
        font-weight: 600;
        font-size: 14px;
        color: #00e5ff;
      }

      .ce-guidance-subtitle {
        font-size: 12px;
        color: rgba(255,255,255,.7);
        line-height: 1.4;
      }

      /* Modifications Placeholder */
      .ce-modifications-placeholder {
        padding: 20px;
        background: rgba(255,255,255,.03);
        border: 1px solid rgba(255,255,255,.1);
        border-radius: 8px;
        text-align: center;
        margin: 12px 0;
      }

      .ce-placeholder-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }

      .ce-placeholder-icon {
        font-size: 24px;
        opacity: 0.6;
      }

      .ce-placeholder-text {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .ce-placeholder-title {
        font-weight: 600;
        font-size: 14px;
        color: rgba(255,255,255,.8);
      }

      .ce-placeholder-subtitle {
        font-size: 12px;
        color: rgba(255,255,255,.5);
        line-height: 1.4;
      }

      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
    `;
  }
}
